module.exports = __webpack_public_path__ + "img/dapitan.9f898dec.png";